// frontend/src/components/delivery/Layout.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Package, CheckSquare, User } from 'lucide-react';

const DeliveryLayout = ({ children }) => {
    const location = useLocation();
    
    const navigation = [
        {
            name: 'Current Orders',
            href: '/delivery/dashboard',
            icon: Package,
            current: location.pathname === '/delivery/dashboard'
        },
        {
            name: 'Delivered Orders',
            href: '/delivery/orders/delivered',
            icon: CheckSquare,
            current: location.pathname === '/delivery/orders/delivered'
        },
        {
            name: 'Profile',
            href: '/delivery/profile',
            icon: User,
            current: location.pathname === '/delivery/profile'
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50">
            <nav className="bg-white shadow-sm border-b">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex justify-between h-16">
                        <div className="flex space-x-8">
                            {navigation.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.href}
                                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium
                                        ${item.current 
                                            ? 'border-blue-500 text-gray-900'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                >
                                    <item.icon className="w-5 h-5 mr-2" />
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </nav>

            <main className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default DeliveryLayout;